import React, { useState, useContext } from "react";
import { makeStyles } from "tss-react/mui";
import { DrawerContext } from "./MultiStepFilterDrawer.js";
import { MultiStepFilterHeader } from "./MultiStepFilterHeader.js";
const useClasses = makeStyles()(() => ({
  multiStepFilterHocComponentContainer: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  multiStepFilterHocHiddenStep: {
    display: "none"
  }
}));
function withMultiStepFilterHoc(WrappedComponents, filterLabel) {
  function StepContainer({
    value,
    defaultState,
    onChange
  }) {
    const [stepHistory, setStepHistory] = useState([0]);
    const [currentState, setCurrentState] = useState(defaultState);
    const { classes, cx } = useClasses();
    const context = useContext(DrawerContext);
    function handleApplyClick() {
      handlePrevStep();
    }
    function handleNextStep(index) {
      if (stepHistory.length === 1) {
        context.onActivate();
      }
      if (stepHistory[stepHistory.length - 1] !== index) {
        setStepHistory([...stepHistory, index]);
      }
    }
    function handlePrevStep() {
      if (stepHistory.length === 2) {
        context.onDeactivate();
      }
      if (stepHistory.length > 1) {
        setStepHistory([...stepHistory.slice(0, -1)]);
      }
    }
    function handleStateChange(newState) {
      setCurrentState(newState);
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, stepHistory.length > 1 ? /* @__PURE__ */ React.createElement(MultiStepFilterHeader, { onBack: handlePrevStep, label: filterLabel, onClose: context.onClose }) : null, WrappedComponents.map((Comp, index) => /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(
          classes.multiStepFilterHocComponentContainer,
          index !== stepHistory[stepHistory.length - 1] && classes.multiStepFilterHocHiddenStep
        )
      },
      /* @__PURE__ */ React.createElement(
        Comp,
        {
          isStepActive: index === stepHistory[stepHistory.length - 1],
          value,
          onChange,
          defaultState: currentState,
          onStateChange: handleStateChange,
          onApply: handleApplyClick,
          onNextStep: handleNextStep
        }
      )
    )));
  }
  return StepContainer;
}
export {
  withMultiStepFilterHoc
};
//# sourceMappingURL=MultiStepFilterHoc.js.map
